import React from "react";
import { Outlet } from "react-router-dom";
import { GoogleMapsProvider } from "../../places/context/GoogleMapsContext";

export default function MapsLayout() {
  return (
    <GoogleMapsProvider>
      <Outlet />
    </GoogleMapsProvider>
  );
}